// extracted by mini-css-extract-plugin
module.exports = {"main":"SayingView_main_1MhEH","saying_view":"SayingView_saying_view_368G0","main_title":"SayingView_main_title_dqBnL"};